import React from 'react'
import { useDimensions } from 'src/ui/dimensions'

import { Simulator as Desc } from './desk'
import { Simulator as Mob } from './mob'

type Props = {
  images: TImages
}
export const Simulator: React.FC<Props> = ({ images }) => {
  const { isMobile } = useDimensions()
  return isMobile ? <Mob images={images} /> : <Desc images={images} />
}
